export const RESPONSE_DOCUMENTS = 'DOCUMENTS';
export const RESPONSE_REASON = 'REASON';
export const RESPONSE_REASON_NO_PATIENT = 'REASON_NO_PATIENT';
export const RESPONSE_REASON_NO_RECORDS = 'REASON_NO_RECORDS';
export const RESPONSE_REASON_NOT_CURRENTLY_AVAILABLE =
  'REASON_NOT_CURRENTLY_AVAILABLE';
export const RESPONSE_REASON_OTHER = 'REASON_OTHER';
